// Vuex Agents module mutations types
export const FILL_LIST = 'FILL_LIST';
export const FILL_FEEDBACK_LIST = 'FILL_FEEDBACK_LIST';
